import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconSorting",
  "use": "IconSorting-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconSorting\"><path d=\"M19.5468 16.7069L16.0112 20.2425 12.4757 16.7069M16 5V20.2427M11.5468 8.53576L8.01123 5.00022 4.4757 8.53576M8 20.2427V4.99995\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol